<template>
  <Icon
    name="programRules"
    :height="22"
    :width="20"
    :scale="1.5"
  >
    <path
      d="M20.75 22.3333C20.1977 22.3333 19.75 22.781 19.75 23.3333V24.3283L10.25 19.5783V14.5592L14.525 9.66666H20.3333C20.8856 9.66666 21.3333 9.21895 21.3333 8.66666V1.16666C21.3333 0.61438 20.8856 0.166664 20.3333 0.166664H12.8333C12.281 0.166664 11.8333 0.614379 11.8333 1.16666V7.925L7.55833 12.8333H1.75C1.19772 12.8333 0.75 13.281 0.75 13.8333V21.3333C0.75 21.8856 1.19772 22.3333 1.75 22.3333H8.66667L19.75 27.875V30.8333C19.75 31.3856 20.1977 31.8333 20.75 31.8333H28.25C28.8023 31.8333 29.25 31.3856 29.25 30.8333V23.3333C29.25 22.781 28.8023 22.3333 28.25 22.3333H20.75ZM15 3.33333H18.1667V6.5H15V3.33333ZM7.08333 19.1667H3.91667V16H7.08333V19.1667ZM26.0833 28.6667H22.9167V25.5H26.0833V28.6667Z"/>
  </Icon>
</template>

<script>
  import Icon from "../Elements/Icon";

  export default {
    name: "ProgramRules",
    components: { Icon },
  }
</script>
